import { initReact } from '../../js/vendor/react';
import * as SharedComponents from './components';

export function initSharedComponents() {
    initReact();
    window['SharedComponents'] = window['SharedComponents'] || SharedComponents;
}

initSharedComponents();
